<template>
	<div class="layout-selection-wrapper">
		<breakcrum :items="breadcrumItems"></breakcrum>
		<div class="section-header">
			{{ $t("layoutSelection.header") }}
		</div>
		<div class="section-subheader">
			{{ $t("layoutSelection.subheader") }}
		</div>

		<div class="layouts-wrapper">
			<div v-for="layout of layouts" :key="layout._id" class="layout">
				<div
					class="icon image-wrapper"
					@click="setSelectedLayoutImage(layout.icon)"
				>
					<img :src="layout.icon" alt="" />
				</div>
				<div class="text">{{ layout.name }}</div>
				<div
					class="radio-button-wrapper"
					:class="{
						selected:
							selectedLayout && selectedLayout._id == layout._id,
					}"
					@click="handleLayoutRadioClick(layout)"
				>
					<svg
						width="24"
						height="25"
						viewBox="0 0 24 25"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<circle cx="12" cy="12.001" r="12" fill="#7345B2" />
						<g filter="url(#filter0_d_472_14101)">
							<path
								d="M10.4538 16.2868L6.85693 12.6301L7.75614 11.716L10.4538 14.4585L16.2434 8.57251L17.1426 9.48668L10.4538 16.2868Z"
								fill="#F4EFFB"
							/>
						</g>
						<defs>
							<filter
								id="filter0_d_472_14101"
								x="2.85693"
								y="8.57251"
								width="18.2856"
								height="15.7144"
								filterUnits="userSpaceOnUse"
								color-interpolation-filters="sRGB"
							>
								<feFlood
									flood-opacity="0"
									result="BackgroundImageFix"
								/>
								<feColorMatrix
									in="SourceAlpha"
									type="matrix"
									values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
									result="hardAlpha"
								/>
								<feOffset dy="4" />
								<feGaussianBlur stdDeviation="2" />
								<feComposite in2="hardAlpha" operator="out" />
								<feColorMatrix
									type="matrix"
									values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"
								/>
								<feBlend
									mode="normal"
									in2="BackgroundImageFix"
									result="effect1_dropShadow_472_14101"
								/>
								<feBlend
									mode="normal"
									in="SourceGraphic"
									in2="effect1_dropShadow_472_14101"
									result="shape"
								/>
							</filter>
						</defs>
					</svg>
				</div>
			</div>
		</div>

		<div class="page-footer">
			<div class="footer-button outlined" @click="handleBackClick">
				{{ $t("buttonText.back") }}
			</div>
			<div class="footer-button" @click="handleNextClick">
				{{ $t("buttonText.next") }}
			</div>
		</div>

		<div
			v-show="isImagePopupVisible"
			class="popup-wrapper"
			@click="isImagePopupVisible = false"
		>
			<div class="popup-container" @click.stop>
				<img :src="selectedLayoutImage" alt="" />
			</div>
		</div>
	</div>
</template>

<script>
import breakcrum from "@/components/breakcrum.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
	name: "LayoutSelection",
	components: {
		breakcrum,
	},
	data: () => ({
		breadcrumItems: [],
		selectedLayoutImage: "",
		isImagePopupVisible: false,
	}),
	computed: {
		...mapGetters(["layouts", "selectedLayout", "selectedLook"]),
	},
	created() {
		this.breadcrumItems = [
			{
				text: this.$t("breadcrums.roomLayout"),
				svg: `
                    <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="13.6052" cy="13.0674" r="12.7273" fill="#7345B2"/>
                            <rect x="7.2417" y="6.70361" width="12.7273" height="12.7273" fill="#7345B2"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4792 7.25049C8.97784 7.25049 7.76074 8.46759 7.76074 9.96896V16.1775C7.76074 17.6789 8.97784 18.896 10.4792 18.896H16.974C18.4754 18.896 19.6925 17.6789 19.6925 16.1775V11.2724V9.72702C19.6925 8.35927 18.5837 7.25049 17.216 7.25049H10.4792ZM8.95392 9.96896C8.95392 9.12656 9.63682 8.44367 10.4792 8.44367H12.2839V10.0728H13.0793V8.44367H17.216C17.9247 8.44367 18.4993 9.01825 18.4993 9.72702V11.2724V12.6631H17.4972V13.4585H18.4993V16.1775C18.4993 17.0199 17.8164 17.7028 16.974 17.7028H13.4156L13.4156 14.4058C13.4156 13.8827 13.8397 13.4585 14.3629 13.4585H15.4747V12.6631H14.3629C13.4004 12.6631 12.6202 13.4433 12.6202 14.4058V15.7214H10.0524V16.5168L12.6202 16.5168V17.7028H10.4792C9.63682 17.7028 8.95392 17.0199 8.95392 16.1775V11.8016H12.7579V11.0062H8.95392V9.96896Z" fill="#F4EFFB"/>
                    </svg>
                    `,
				active: true,
			},
			{
				text: this.$t("breadcrums.roomDimensions"),
				svg: `
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="13.0002" cy="13.0674" r="12.7273" fill="#DDD2EC"/>
                        <rect x="6.63672" y="6.70361" width="12.7273" height="12.7273" fill="#DDD2EC"/>
                        <rect x="7.43213" y="7.49902" width="11.1364" height="11.1364" rx="1.59091" stroke="#7345B2" stroke-width="1.19318"/>
                        <path d="M13.0015 8.65649L13.0015 17.4065" stroke="#7345B2" stroke-width="0.795455" stroke-linecap="round"/>
                        <path d="M11.8076 9.45195L13.0008 8.65649L14.194 9.45195" stroke="#7345B2" stroke-width="0.795455" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.8076 16.611L13.0008 17.4065L14.194 16.611" stroke="#7345B2" stroke-width="0.795455" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M17.7734 13.0315L8.22798 13.0315" stroke="#7345B2" stroke-width="0.795455" stroke-linecap="round"/>
                        <path d="M16.978 11.8384L17.7734 13.0316L16.978 14.2247" stroke="#7345B2" stroke-width="0.795455" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9.02348 11.8384L8.22803 13.0316L9.02348 14.2247" stroke="#7345B2" stroke-width="0.795455" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    `,
				active: false,
			},
		];
	},
	mounted() {
		if (!this.selectedLook) {
			this.$router.push("/");
			return;
		}
	},
	methods: {
		...mapActions(["fetchSizes"]),
		...mapMutations(["setSelectedLayout"]),
		handleLayoutRadioClick(layout) {
			this.setSelectedLayout(layout);
			this.fetchSizes(layout._id);
		},
		handleBackClick() {
			if (this.selectedLook) {
				this.$router.push("/?lookid=" + this.selectedLook._id);
			} else {
				this.$router.push("/");
			}
		},
		handleNextClick() {
			if (this.selectedLook) {
				this.$router.push("/enter-dimensions");
			}
		},
		setSelectedLayoutImage(image) {
			this.selectedLayoutImage = image;
			this.isImagePopupVisible = true;
		},
	},
	destroyed() {},
};
</script>

<style lang="scss" scoped>
.layout-selection-wrapper {
	height: 100%;
	width: 100%;
	padding-top: 1rem;
	// padding of the footer plus the button padding plus the button font plus 39px arbitry
	padding-bottom: calc(1.3125rem + 2.6875rem + 1.5rem + 1.125rem + 2.4375rem);
	position: relative;

	display: flex;
	flex-direction: column;
	align-items: center;

	@include custom-min(768px) {
		padding-top: 2.375rem;
		padding-bottom: calc(1.75rem * 2 + 1rem * 2 + 9.9375rem / 2);
	}

	.section-header {
		font-family: $heading-font;
		font-style: normal;
		font-weight: 400;
		font-size: 1.25rem;
		line-height: 140%;
		text-align: center;
		margin-top: 2rem;
		// padding: 0 1rem;
		width: 91%;

		@include custom-min(768px) {
			font-size: 2rem;
			margin-top: 3rem;
		}
	}

	.section-subheader {
		font-style: normal;
		font-weight: 400;
		font-size: 0.875rem;
		line-height: 150%;
		text-align: center;
		margin-top: 0.75rem;
		// padding: 0 1rem;
		width: 91%;

		@include custom-min(768px) {
			font-size: 1.25rem;
			margin-top: 1rem;
		}
	}

	.layouts-wrapper {
		margin-top: 2.125rem;
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 2rem 3.625rem;
		width: 78%;

		@include custom-min(768px) {
			width: 65%;
			margin-top: 4rem;
			grid-template-columns: 1fr 1fr 1fr;
			gap: 1.5rem 11.625rem;
		}

		.layout {
			display: flex;
			flex-direction: column;
			align-items: center;

			.icon {
				margin-bottom: 1.5rem;
			}

			.text {
				margin-bottom: 1rem;
				font-style: normal;
				font-weight: 400;
				font-size: 1rem;
				line-height: 140%;
				text-align: center;
				letter-spacing: 0.01em;

				@include custom-min(768px) {
					margin-bottom: 1.5rem;
					font-size: 1.25rem;
				}
			}

			.radio-button-wrapper {
				background-color: color(background-light-purple-1);
				height: 1.5rem;
				width: 1.5rem;
				position: relative;
				border-radius: 50%;

				@include custom-min(768px) {
					height: 1.75rem;
					width: 1.75rem;
				}

				&.selected {
					svg {
						display: block;
					}
				}

				svg {
					display: none;
					height: 100%;
					width: 100%;
					position: absolute;
					top: 0;
					left: 0;
				}
			}
		}
	}

	.popup-wrapper {
		height: 100vh;
		width: 100%;
		background: rgba(13, 13, 13, 0.7);
		position: absolute;
		top: 0;
		left: 0;
		display: flex;
		justify-content: center;
		align-items: center;

		.popup-container {
			width: 90%;

			img {
				height: auto;
				width: 100%;
				display: block;
			}

			@include custom-min(768px) {
				width: 60%;
			}
		}
	}

	.page-footer {
		.outlined {
			margin-right: 1.5rem;
		}
	}
}
</style>
